
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dyspozycje-sprzedazowe",
      function () {
        return require("private-next-pages/dyspozycje-sprzedazowe.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dyspozycje-sprzedazowe"])
      });
    }
  